const category = [
    {
        id: 1,
        name: "Laravel",
    },
    {
        id: 2,
        name: "Javascript",
    },
    {
        id: 3,
        name: "Redux",
    },
    {
        id: 4,
        name: "React",
    },
    {
        id: 5,
        name: "PHP",
    },
];

export default category;
